import React from 'react';
import Styles from '../components/Topo.module.css';

import logo from '../img/RC.png';
import foto from '../img/IMG_9295.JPG';
const Topo = () => {
  return (
    <div>
      <header className={Styles.topo}>
        <div className={Styles.areaLogo}>
          <img src={logo} alt='Logo Repertório de valor' />
        </div>
        <h1>REPERTÓRIO COMPORTAMENTAL</h1>
        <h2>Comportamento: a força por trás de uma imagem de valor.</h2>
        <p>
          Descubra como o desenvolvimento do seu <strong>repertório comportamental </strong> pode te transformar em
          alguém com mais credibilidade, autoridade e confiança.
        </p>
      </header>
 <section className={Styles.Problemas}>
      <div className={Styles.areaProblemas}>  
        <div className={Styles.areaImage}>
          <img className={Styles.imagemPrincipal} src={foto} alt='Foto Rafaella' />
        </div>
        <div className={Styles.areaText} >
        <h2>Você já sentiu que, apesar de todo o seu conhecimento, ainda não recebe o reconhecimento que merece?</h2>
        <p>
          Talvez você acredite que, para se destacar, seja <strong>preciso adquirir mais conhecimento técnico</strong>.
          Mas a verdade é que conhecimento técnico, por melhor que seja, <strong>não é o suficiente.</strong>{' '}
        </p>
        <br />
        <p>
          Hoje, ser boa no que faz já não basta. O verdadeiro diferencial está em <strong>como você se comunica e como as
          pessoas te percebem através do seu comportamento.</strong>
        </p>
           <div className={Styles.areaBtn}>
            <button
          className={Styles.btn}
          onClick={() => {
            const el = document.getElementById('formulario-inscricao');
            if (el) el.scrollIntoView({ behavior: 'smooth' });
          }}>
          INSCREVA-SE AGORA
        </button>
       </div>
        </div>

        </div>
          </section>
    </div>
    
  );
};

export default Topo;
